<script setup lang="ts">
import Skeleton, { type SkeletonProps } from 'primevue/skeleton';
import { computed, onMounted, ref } from 'vue';

const {
  shape = 'rectangle',
  height = 'md',
  count = 1,
  timeout = 1000,
} = defineProps<{
  shape?: SkeletonProps['shape'];
  height?: keyof typeof heights;
  count?: number;
  timeout?: number;
}>();

const heights = {
  md: '1rem',
  lg: '2.5rem',
  xl: '4.5rem',
} as const;

const show = ref(false);

const heightRem = computed(() => heights[height]);

onMounted(() => setTimeout(() => (show.value = true), timeout));
</script>

<template>
  <div
    :class="{ 'opacity-0': !show }"
    class="flex w-full flex-col gap-2 transition-opacity duration-300"
  >
    <Skeleton v-for="i in count" :key="i" :shape="shape" :height="heightRem" />
  </div>
</template>
